<template>
    <div class="mobile-bg-container">

        <div class="login-container">
            <div class="login-box">
                <div class="box-left">
                    <!-- <img class="logo" :src="logo" alt=""> -->
                </div>
                <div class="box-right">
                    <div class="sys-name">赛事评分系统</div>
                    <form>
                        <div class="input-row">
                            <el-input v-model="lForm.acct"  placeholder="请输入账号" class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="lForm.pwd"  placeholder="请输入密码" class="el-input-fifty-height" show-password></el-input>
                        </div>
                        <div class="check-row">
                            <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
                        </div>

                        <div class="input-row" style="margin-bottom: 15px;">
                            <el-button type="primary" @click="login" native-type="submit">登 录</el-button>
                        </div>
                    </form>
                 
                </div>
            </div>
        </div>

        <!-- <div v-if="false" style="margin-top:20%;">
            <div>
                <img src="../../assets/images/logo.jpg" style="display: block;width: 150px;margin: 20px auto 0;border-radius: 50%;" />
            </div>
            <div>
                <p style="color: #fff; text-align: center;font-size: 30px;letter-spacing: 0.3rem;margin: 0 0 1% 0;">
                    赛事评分系统
                </p>
            </div>
            <div style="width:80%;max-width: 400px;margin: 0 auto;padding: 2%;">
                <el-form :model="lForm" ref="lForm" @keyup.native.enter="login">
                    <el-form-item label="账号">
                        <el-input v-model="lForm.acct" :autofocus="true"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="lForm.pwd" show-password></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 15%;">
                        <el-button type="primary" @click="login" style="display: block;width: 100%;"
                            :loading="loginBtnIsLoading">登&nbsp;录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div> -->
    </div>
</template>

<script>
import AppServices from "../../request-server/request-services/app-services";
import BrowserStorage from './../../utils/utils-browser-storage';
export default {
    props: ["redirect"],
    data() {
        return {
            isMobile:true,
            lForm: {
                acct: "",
                pwd: ""
            },
            loginBtnIsLoading: false,
            redirectUrl: this.redirect,
            rememberPassword:true
        }
    },
    created() {
        document.addEventListener('gesturestart', function (e) {
            e.preventDefault();
        })

        if(window.innerWidth >= 900){
            this.isMobile = false;
        }

        this.lForm.acct = BrowserStorage.getItem('username')
        this.lForm.pwd = BrowserStorage.getItem('password')
    },
    methods: {
        login() {
            if (this.lForm) {
                if (!this.lForm.acct) {
                    this.$message.error("请输入账号");
                    return;
                }
                if (!this.lForm.pwd) {
                    this.$message.error("请输入密码");
                    return;
                }
            } else {
                this.$message.error("请输入账号密码");
                return;
            }
            this.loginBtnIsLoading = true;
            AppServices.userLogin(this.lForm.acct, this.lForm.pwd)
                .then(resData => {
                    this.$store.commit("loginin", resData.data.LoginToken);
                    //登录成功跳转

                    if(this.rememberPassword){
                        BrowserStorage.setItem('username',this.lForm.acct);
                        BrowserStorage.setItem('password',this.lForm.pwd);
                    }

                    let beforeUrl = this.redirectUrl;
                    //let jumpUrl = beforeUrl || "/referee/inputrecord";
                    this.$router.replace("/referee/inputrecord");
                })
                .finally(() => {
                    this.loginBtnIsLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-bg-container {
    position: absolute;
    width: 100%;
    height: 100vh;
    // background-color: #387cbd;
    // background: linear-gradient(#559ae7, #3a8be6);

    background: url("../../assets/images/bg.jpg") no-repeat 0 0 /100% 100%;
    position: relative;
    overflow: hidden;

    .login-container {
        width: 40rem;
        height: 27rem;
        // background: url("../../assets/images/bg.jpg") no-repeat 0 0 /100% 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 50%;
        transform: translate(-50%, -50%);

        .login-box {
            width: 40rem;
            height: 27rem;
            overflow: hidden;
            position: relative;
            margin: 10% auto 0;
            background: transparent;
            border-radius: 5px;

            .box-left {
                float: left;
                width: 23rem;
                height: 23rem;
                background: url("../../assets/images/page-left.jpg") no-repeat 0 0 /100% 100%;
                position: relative;

                .logo {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: 48px;
                    left: 37px;
                }
            }

            .box-right {
                float: left;
                height: 23rem;
                width: 17rem;
                background: #fff;
                // text-align: center;
                box-sizing: border-box;

                .sys-name {
                    font-size: 2rem;
                    font-family: SourceHanSansCN-Light;
                    color: #56a9ff;
                    // margin-left: 52px;
                    margin-top: 20px;
                    text-align: center;
                }

                .welcome-text {
                    font-family: SourceHanSansCN-Light;
                    font-size: 20px;
                    color: #b2b4b9;
                    // margin-left: 122px;
                    margin-top: 6px;
                    text-align: center;
                }

                form {
                    width: 80%;
                    margin: 25px auto 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .check-row {
                        width: 100%;
                        margin-bottom: 29px;
                        margin-top: -4px;

                        // height: 48px;
                    }

                    .input-row {
                        // width: 100%;
                        width: 15rem;
                        height: 3rem;
                        // text-align: center;
                        margin-bottom: 1.3rem;

                        // &:last-child {
                        //     margin-bottom: 25px;
                        // }
                     
                        button {
                            width: 100%;
                            height: 48px;
                            // font-family: SourceHanSansCN-Light;
                            font-size: 20px;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}
</style>